// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2N5IIDXJll0JnirpOeMqwo","mobile":"_22F3YaEeoNQngVc76mHDTZ","iconWrapper":"_1UdZ2jotGYMtHbwO304YOv","label":"M1ghEY-6iCG_o8XYZwGRx","imgWrapper":"_3pSd0xoSoU4QjLpDucfJPp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMFiltersTitle/OMFiltersTitle.scss
// module id = 1645
// module chunks = 0